import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            探索当前最受关注的吃瓜话题标签，快速找到你感兴趣的内容方向
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((topic) => (
            <div
              key={topic.id}
              className={`group relative flex items-center gap-2 px-5 py-3 rounded-xl border cursor-pointer transition-all duration-200 ${
                topic.hot
                  ? 'border-primary-200 bg-primary-50/70 hover:bg-primary-100 hover:border-primary-300'
                  : 'border-background-200 bg-background-50 hover:bg-background-100 hover:border-background-300'
              }`}
            >
              {topic.hot && (
                <span className="absolute -top-2 -right-2 w-5 h-5 flex items-center justify-center rounded-full bg-accent-500">
                  <i className="ri-fire-line text-[10px] text-white"></i>
                </span>
              )}
              <span className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}